// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__16cF0","title":"AfterImages90_title__31rdS","images":"AfterImages90_images__vx8Ld"};